export const doesDocumentExist = (investment, tag) => {
    return !!(investment && investment.documents && investment.documents[tag] && investment.documents[tag].length > 0);
}

export const getDownloadLink = (doc) => {
    if (doc.type === 'signedAgreement') {
        return `/dashboard/offering/signed_agreement/${doc.investment_id}`
    } else {
        const fileName = encodeURIComponent(doc.name);
        return `/file/${doc.file_id}/${fileName}`;
    }
} 